import React from 'react';

// Classname
import clsx from 'clsx';

// Redux
import { shallowEqual } from 'react-redux';

// Lib
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';

// components
import Img from 'components/Img';

// Actions
import * as actionsCreator from 'pages/Pfizer/reducer';

export const ChangeView: React.FC = () => {
	const dispatch = useAppDispatch();
	const type = useAppSelector(
		(store) => store.pfizer.typeViewList,
		shallowEqual
	);

	const handleChangeType = (viewType: string) => () => {
		dispatch(actionsCreator.changeTypeViewList(viewType));
	};

	return (
		<div className="pfizer__change-view flex flex-ai-center" id="categorized-products-type-view">
			<p className="pfizer__change-type mr10">
				Change View
			</p>
			<div
				className={clsx(
					"pfizer__type-list mr10 flex flex-ai-center flex-jc-center",
					type === 'row' && "pfizer__type-list--active"
				)}
				onClick={handleChangeType('row')}
			>
				<Img isSvg name="lineSvg" />
			</div>
			<div
				className={clsx(
					"pfizer__type-list flex flex-ai-center flex-jc-center",
					type === 'cart' && "pfizer__type-list--active"
				)}
				onClick={handleChangeType('cart')}
			>
				<Img isSvg name="pointsSvg" />
			</div>
		</div>
	);
};

export default ChangeView;
